module.exports = __webpack_public_path__ + "step4_M2F_nakagawa_bridal.86edc747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_M2F_nakagawa_bridal.jpg
// module id = CqsS
// module chunks = 0